// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export const Access = __t.object("Access", {
  id: __t.string(),
  orgId: __t.string(),
  identity: __t.identity(),
});
export type Access = __Infer<typeof Access>;

export const AccessGrant = __t.object("AccessGrant", {
  id: __t.string(),
  orgId: __t.string(),
  targetKind: __t.string(),
  targetId: __t.string(),
  principalKind: __t.string(),
  principalId: __t.string(),
  role: __t.string(),
  createdAt: __t.timestamp(),
});
export type AccessGrant = __Infer<typeof AccessGrant>;

export const Account = __t.object("Account", {
  identity: __t.identity(),
  userId: __t.string(),
  email: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string(),
  isSuperadmin: __t.bool(),
  suspended: __t.bool(),
  impersonatedBy: __t.string(),
  online: __t.bool(),
  createdAt: __t.timestamp(),
  lastSeenAt: __t.timestamp(),
});
export type Account = __Infer<typeof Account>;

export const AdminAudit = __t.object("AdminAudit", {});
export type AdminAudit = __Infer<typeof AdminAudit>;

export const AdminJobs = __t.object("AdminJobs", {});
export type AdminJobs = __Infer<typeof AdminJobs>;

export const AdminMembers = __t.object("AdminMembers", {});
export type AdminMembers = __Infer<typeof AdminMembers>;

export const AdminOrgs = __t.object("AdminOrgs", {});
export type AdminOrgs = __Infer<typeof AdminOrgs>;

export const AdminStats = __t.object("AdminStats", {});
export type AdminStats = __Infer<typeof AdminStats>;

export const AdminStatsRow = __t.object("AdminStatsRow", {
  id: __t.u32(),
  users: __t.u32(),
  usersOnline: __t.u32(),
  orgs: __t.u32(),
  projects: __t.u32(),
  clips: __t.u32(),
  assets: __t.u32(),
  storageUsedBytes: __t.f64(),
  jobsQueued: __t.u32(),
  jobsRunning: __t.u32(),
  jobsFailed: __t.u32(),
  workersOnline: __t.u32(),
  connections: __t.u32(),
  pendingEmails: __t.u32(),
  pendingGc: __t.u32(),
});
export type AdminStatsRow = __Infer<typeof AdminStatsRow>;

export const AdminTrash = __t.object("AdminTrash", {});
export type AdminTrash = __Infer<typeof AdminTrash>;

export const AdminTrashRow = __t.object("AdminTrashRow", {
  id: __t.string(),
  orgId: __t.string(),
  orgName: __t.string(),
  kind: __t.string(),
  targetId: __t.string(),
  name: __t.string(),
  deletedAt: __t.timestamp(),
  deletedByUserId: __t.string(),
  deletedByName: __t.string(),
  purgeAt: __t.timestamp(),
  bytes: __t.f64(),
  rowCount: __t.u32(),
  summary: __t.string(),
});
export type AdminTrashRow = __Infer<typeof AdminTrashRow>;

export const AdminUserRow = __t.object("AdminUserRow", {
  userId: __t.string(),
  email: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string(),
  superadmin: __t.bool(),
  superadminByEnv: __t.bool(),
  suspended: __t.bool(),
  online: __t.bool(),
  orgCount: __t.u32(),
  createdAt: __t.timestamp(),
  lastLoginAt: __t.timestamp(),
  lastActiveAt: __t.timestamp(),
});
export type AdminUserRow = __Infer<typeof AdminUserRow>;

export const AdminUsers = __t.object("AdminUsers", {});
export type AdminUsers = __Infer<typeof AdminUsers>;

export const AdminWorkerRow = __t.object("AdminWorkerRow", {
  id: __t.string(),
  name: __t.string(),
  pools: __t.array(__t.string()),
  gpu: __t.bool(),
  hwaccel: __t.string(),
  hostname: __t.string(),
  version: __t.string(),
  online: __t.bool(),
  disabled: __t.bool(),
  currentJobId: __t.string(),
  lastSeenAt: __t.timestamp(),
  createdAt: __t.timestamp(),
  updateRequested: __t.bool(),
  updateError: __t.string(),
});
export type AdminWorkerRow = __Infer<typeof AdminWorkerRow>;

export const AdminWorkerScaling = __t.object("AdminWorkerScaling", {});
export type AdminWorkerScaling = __Infer<typeof AdminWorkerScaling>;

export const AdminWorkers = __t.object("AdminWorkers", {});
export type AdminWorkers = __Infer<typeof AdminWorkers>;

export const AnalysisResult = __t.object("AnalysisResult", {
  kind: __t.string(),
  data: __t.string(),
});
export type AnalysisResult = __Infer<typeof AnalysisResult>;

export const AnimationPreset = __t.object("AnimationPreset", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  category: __t.string(),
  data: __t.string(),
  createdBy: __t.string(),
  createdAt: __t.timestamp(),
});
export type AnimationPreset = __Infer<typeof AnimationPreset>;

export const AppConfig = __t.object("AppConfig", {
  id: __t.u32(),
  owner: __t.identity(),
});
export type AppConfig = __Infer<typeof AppConfig>;

export const Asset = __t.object("Asset", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  folderId: __t.string(),
  name: __t.string(),
  kind: __t.string(),
  mime: __t.string(),
  ext: __t.string(),
  sizeBytes: __t.f64(),
  totalBytes: __t.f64(),
  status: __t.string(),
  error: __t.string(),
  storageKey: __t.string(),
  proxyKey: __t.string(),
  posterKey: __t.string(),
  filmstripKey: __t.string(),
  filmstripTiles: __t.u32(),
  filmstripIntervalUs: __t.f64(),
  waveformKey: __t.string(),
  durationUs: __t.f64(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  hasVideo: __t.bool(),
  hasAudio: __t.bool(),
  audioChannels: __t.u32(),
  sampleRate: __t.u32(),
  videoCodec: __t.string(),
  audioCodec: __t.string(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
  spaceId: __t.string(),
  sourceId: __t.string(),
  sourceMissing: __t.bool(),
  replacement: __t.string(),
});
export type Asset = __Infer<typeof Asset>;

export const AssetAnalysis = __t.object("AssetAnalysis", {
  id: __t.string(),
  assetId: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  data: __t.string(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
});
export type AssetAnalysis = __Infer<typeof AssetAnalysis>;

export const AssetFolder = __t.object("AssetFolder", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  parentId: __t.string(),
  name: __t.string(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
  spaceId: __t.string(),
  restricted: __t.bool(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
});
export type AssetFolder = __Infer<typeof AssetFolder>;

export const AssetReview = __t.object("AssetReview", {
  assetId: __t.string(),
  orgId: __t.string(),
  scopeId: __t.string(),
  status: __t.string(),
  round: __t.u32(),
  requestedByUserId: __t.string(),
  requestedByName: __t.string(),
  updatedAt: __t.timestamp(),
});
export type AssetReview = __Infer<typeof AssetReview>;

export const AssetShare = __t.object("AssetShare", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  assetId: __t.string(),
  scopeId: __t.string(),
});
export type AssetShare = __Infer<typeof AssetShare>;

export const AssetViewer = __t.object("AssetViewer", {
  id: __t.string(),
  orgId: __t.string(),
  assetId: __t.string(),
  identity: __t.identity(),
});
export type AssetViewer = __Infer<typeof AssetViewer>;

export const AudioFx = __t.object("AudioFx", {
  pan: __t.f64(),
  eqLow: __t.f64(),
  eqMid: __t.f64(),
  eqHigh: __t.f64(),
  highpass: __t.f64(),
  lowpass: __t.f64(),
  compressor: __t.f64(),
  echo: __t.f64(),
  echoDelayMs: __t.f64(),
});
export type AudioFx = __Infer<typeof AudioFx>;

export const AuditLog = __t.object("AuditLog", {
  id: __t.string(),
  at: __t.timestamp(),
  actorUserId: __t.string(),
  actorName: __t.string(),
  orgId: __t.string(),
  action: __t.string(),
  target: __t.string(),
  detail: __t.string(),
});
export type AuditLog = __Infer<typeof AuditLog>;

export const AuthSession = __t.object("AuthSession", {
  id: __t.string(),
  userId: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  lastUsedAt: __t.timestamp(),
  userAgent: __t.string(),
  ip: __t.string(),
  impersonatorUserId: __t.string(),
});
export type AuthSession = __Infer<typeof AuthSession>;

export const AuthUser = __t.object("AuthUser", {
  userId: __t.string(),
  email: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string(),
  googleSub: __t.string(),
  emailVerified: __t.bool(),
  superadmin: __t.bool(),
  suspended: __t.bool(),
  createdAt: __t.timestamp(),
  lastLoginAt: __t.timestamp(),
});
export type AuthUser = __Infer<typeof AuthUser>;

export const BillingEvent = __t.object("BillingEvent", {
  id: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  createdAt: __t.timestamp(),
});
export type BillingEvent = __Infer<typeof BillingEvent>;

export const BillingState = __t.object("BillingState", {
  id: __t.u32(),
  lastRunAt: __t.timestamp(),
  lastColdRunAt: __t.timestamp(),
  billingEnabledAt: __t.option(__t.timestamp()),
});
export type BillingState = __Infer<typeof BillingState>;

export const Clip = __t.object("Clip", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  trackId: __t.string(),
  kind: __t.string(),
  assetId: __t.option(__t.string()),
  name: __t.string(),
  startUs: __t.f64(),
  durationUs: __t.f64(),
  inUs: __t.f64(),
  speed: __t.f64(),
  get transform() {
    return Transform;
  },
  get crop() {
    return Crop;
  },
  get color() {
    return ColorAdjust;
  },
  get videoFx() {
    return VideoFx;
  },
  videoFadeInUs: __t.f64(),
  videoFadeOutUs: __t.f64(),
  get transitionIn() {
    return __t.option(TransitionRef);
  },
  volume: __t.f64(),
  muted: __t.bool(),
  audioFadeInUs: __t.f64(),
  audioFadeOutUs: __t.f64(),
  get audioFx() {
    return AudioFx;
  },
  get text() {
    return __t.option(TextProps);
  },
  fillColor: __t.string(),
  get keyframes() {
    return __t.array(Keyframe);
  },
  linkId: __t.option(__t.string()),
  lockedBy: __t.option(__t.identity()),
  lockedByName: __t.string(),
  updatedAt: __t.timestamp(),
  updatedByName: __t.string(),
  get transitionOut() {
    return __t.option(TransitionRef);
  },
  ext: __t.string(),
  scopeId: __t.string(),
});
export type Clip = __Infer<typeof Clip>;

export const ClipInput = __t.object("ClipInput", {
  id: __t.string(),
  trackId: __t.string(),
  kind: __t.string(),
  assetId: __t.option(__t.string()),
  name: __t.string(),
  startUs: __t.f64(),
  durationUs: __t.f64(),
  inUs: __t.f64(),
  speed: __t.f64(),
  get transform() {
    return Transform;
  },
  get crop() {
    return Crop;
  },
  get color() {
    return ColorAdjust;
  },
  get videoFx() {
    return VideoFx;
  },
  videoFadeInUs: __t.f64(),
  videoFadeOutUs: __t.f64(),
  get transitionIn() {
    return __t.option(TransitionRef);
  },
  volume: __t.f64(),
  muted: __t.bool(),
  audioFadeInUs: __t.f64(),
  audioFadeOutUs: __t.f64(),
  get audioFx() {
    return AudioFx;
  },
  get text() {
    return __t.option(TextProps);
  },
  fillColor: __t.string(),
  get keyframes() {
    return __t.array(Keyframe);
  },
  linkId: __t.option(__t.string()),
  get transitionOut() {
    return __t.option(TransitionRef);
  },
  ext: __t.string(),
});
export type ClipInput = __Infer<typeof ClipInput>;

export const ClipPatch = __t.object("ClipPatch", {
  trackId: __t.option(__t.string()),
  name: __t.option(__t.string()),
  startUs: __t.option(__t.f64()),
  durationUs: __t.option(__t.f64()),
  inUs: __t.option(__t.f64()),
  speed: __t.option(__t.f64()),
  get transform() {
    return __t.option(Transform);
  },
  get crop() {
    return __t.option(Crop);
  },
  get color() {
    return __t.option(ColorAdjust);
  },
  get videoFx() {
    return __t.option(VideoFx);
  },
  videoFadeInUs: __t.option(__t.f64()),
  videoFadeOutUs: __t.option(__t.f64()),
  get transitionIn() {
    return __t.option(TransitionPatch);
  },
  volume: __t.option(__t.f64()),
  muted: __t.option(__t.bool()),
  audioFadeInUs: __t.option(__t.f64()),
  audioFadeOutUs: __t.option(__t.f64()),
  get audioFx() {
    return __t.option(AudioFx);
  },
  get text() {
    return __t.option(TextProps);
  },
  fillColor: __t.option(__t.string()),
  get keyframes() {
    return __t.option(__t.array(Keyframe));
  },
  get linkId() {
    return __t.option(LinkPatch);
  },
  get transitionOut() {
    return __t.option(TransitionPatch);
  },
  ext: __t.option(__t.string()),
});
export type ClipPatch = __Infer<typeof ClipPatch>;

export const ClipUpdate = __t.object("ClipUpdate", {
  id: __t.string(),
  get patch() {
    return ClipPatch;
  },
});
export type ClipUpdate = __Infer<typeof ClipUpdate>;

export const ColorAdjust = __t.object("ColorAdjust", {
  brightness: __t.f64(),
  contrast: __t.f64(),
  saturation: __t.f64(),
  hue: __t.f64(),
  gamma: __t.f64(),
  temperature: __t.f64(),
});
export type ColorAdjust = __Infer<typeof ColorAdjust>;

export const ColorPalette = __t.object("ColorPalette", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  colors: __t.array(__t.string()),
  createdBy: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type ColorPalette = __Infer<typeof ColorPalette>;

export const Comment = __t.object("Comment", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  parentId: __t.option(__t.string()),
  authorUserId: __t.string(),
  authorName: __t.string(),
  authorAvatar: __t.string(),
  body: __t.string(),
  timeUs: __t.option(__t.f64()),
  clipId: __t.option(__t.string()),
  createdAt: __t.timestamp(),
  editedAt: __t.option(__t.timestamp()),
  resolved: __t.bool(),
  resolvedByName: __t.string(),
  endUs: __t.option(__t.f64()),
  drawing: __t.string(),
  jobId: __t.string(),
  versionId: __t.string(),
  scopeId: __t.string(),
  linkId: __t.string(),
  assetRound: __t.u32(),
});
export type Comment = __Infer<typeof Comment>;

export const Connection = __t.object("Connection", {
  connectionId: __t.connectionId(),
  identity: __t.identity(),
  connectedAt: __t.timestamp(),
  impersonatedBy: __t.string(),
});
export type Connection = __Infer<typeof Connection>;

export const Crop = __t.object("Crop", {
  left: __t.f64(),
  right: __t.f64(),
  top: __t.f64(),
  bottom: __t.f64(),
});
export type Crop = __Infer<typeof Crop>;

// The tagged union or sum type for the algebraic type `EditOp`.
export const EditOp = __t.enum("EditOp", {
  get AddTrack() {
    return TrackInput;
  },
  get UpdateTrack() {
    return TrackUpdate;
  },
  RemoveTrack: __t.string(),
  get AddClip() {
    return ClipInput;
  },
  get UpdateClip() {
    return ClipUpdate;
  },
  RemoveClip: __t.string(),
  get AddMarker() {
    return MarkerInput;
  },
  get UpdateMarker() {
    return MarkerInput;
  },
  RemoveMarker: __t.string(),
});
export type EditOp = __Infer<typeof EditOp>;

export const EmailOutbox = __t.object("EmailOutbox", {
  id: __t.string(),
  to: __t.string(),
  template: __t.string(),
  payload: __t.string(),
  createdAt: __t.timestamp(),
  attempts: __t.u32(),
  lastError: __t.string(),
});
export type EmailOutbox = __Infer<typeof EmailOutbox>;

export const GroupMember = __t.object("GroupMember", {
  id: __t.string(),
  orgId: __t.string(),
  groupId: __t.string(),
  userId: __t.string(),
});
export type GroupMember = __Infer<typeof GroupMember>;

export const Job = __t.object("Job", {
  id: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  status: __t.string(),
  pool: __t.string(),
  assetId: __t.string(),
  projectId: __t.string(),
  title: __t.string(),
  settings: __t.string(),
  progress: __t.f64(),
  workerId: __t.string(),
  workerName: __t.string(),
  attempts: __t.u32(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  startedAt: __t.option(__t.timestamp()),
  finishedAt: __t.option(__t.timestamp()),
  heartbeatAt: __t.option(__t.timestamp()),
  resultKey: __t.string(),
  resultBytes: __t.f64(),
  error: __t.string(),
  priority: __t.u32(),
  billedMinutes: __t.f64(),
  scopeId: __t.string(),
  parentId: __t.string(),
});
export type Job = __Infer<typeof Job>;

export const JobPayload = __t.object("JobPayload", {
  jobId: __t.string(),
  pool: __t.string(),
  data: __t.string(),
});
export type JobPayload = __Infer<typeof JobPayload>;

export const Keyframe = __t.object("Keyframe", {
  property: __t.string(),
  timeUs: __t.f64(),
  value: __t.f64(),
  easing: __t.string(),
});
export type Keyframe = __Infer<typeof Keyframe>;

// The tagged union or sum type for the algebraic type `LinkPatch`.
export const LinkPatch = __t.enum("LinkPatch", {
  Set: __t.string(),
  Clear: __t.unit(),
});
export type LinkPatch = __Infer<typeof LinkPatch>;

export const Logo = __t.object("Logo", {
  id: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  url: __t.string(),
  updatedAt: __t.timestamp(),
  scopeId: __t.string(),
});
export type Logo = __Infer<typeof Logo>;

export const MagicLink = __t.object("MagicLink", {
  tokenHash: __t.string(),
  email: __t.string(),
  redirect: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  used: __t.bool(),
});
export type MagicLink = __Infer<typeof MagicLink>;

export const Marker = __t.object("Marker", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  timeUs: __t.f64(),
  label: __t.string(),
  color: __t.string(),
  scopeId: __t.string(),
});
export type Marker = __Infer<typeof Marker>;

export const MarkerInput = __t.object("MarkerInput", {
  id: __t.string(),
  timeUs: __t.f64(),
  label: __t.string(),
  color: __t.string(),
});
export type MarkerInput = __Infer<typeof MarkerInput>;

export const McpKey = __t.object("McpKey", {
  id: __t.string(),
  userId: __t.string(),
  name: __t.string(),
  tokenHash: __t.string(),
  prefix: __t.string(),
  createdAt: __t.timestamp(),
  lastUsedAt: __t.option(__t.timestamp()),
  expiresAt: __t.option(__t.timestamp()),
});
export type McpKey = __Infer<typeof McpKey>;

export const McpKeyRow = __t.object("McpKeyRow", {
  id: __t.string(),
  name: __t.string(),
  prefix: __t.string(),
  createdAt: __t.timestamp(),
  lastUsedAt: __t.option(__t.timestamp()),
  expiresAt: __t.option(__t.timestamp()),
});
export type McpKeyRow = __Infer<typeof McpKeyRow>;

export const MediaResult = __t.object("MediaResult", {
  durationUs: __t.f64(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  hasVideo: __t.bool(),
  hasAudio: __t.bool(),
  audioChannels: __t.u32(),
  sampleRate: __t.u32(),
  videoCodec: __t.string(),
  audioCodec: __t.string(),
  proxyKey: __t.string(),
  posterKey: __t.string(),
  filmstripKey: __t.string(),
  filmstripTiles: __t.u32(),
  filmstripIntervalUs: __t.f64(),
  waveformKey: __t.string(),
  derivedBytes: __t.f64(),
});
export type MediaResult = __Infer<typeof MediaResult>;

export const ModuleBuild = __t.object("ModuleBuild", {
  id: __t.u32(),
  stamp: __t.f64(),
  publishedAt: __t.timestamp(),
});
export type ModuleBuild = __Infer<typeof ModuleBuild>;

export const MotionTrack = __t.object("MotionTrack", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  assetId: __t.string(),
  clipId: __t.string(),
  name: __t.string(),
  box: __t.string(),
  atUs: __t.f64(),
  fromUs: __t.f64(),
  toUs: __t.f64(),
  jobId: __t.string(),
  status: __t.string(),
  error: __t.string(),
  data: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
});
export type MotionTrack = __Infer<typeof MotionTrack>;

export const MyMcpKeys = __t.object("MyMcpKeys", {});
export type MyMcpKeys = __Infer<typeof MyMcpKeys>;

export const Notification = __t.object("Notification", {
  id: __t.string(),
  userId: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  projectId: __t.string(),
  projectName: __t.string(),
  commentId: __t.string(),
  actorName: __t.string(),
  actorAvatar: __t.string(),
  title: __t.string(),
  body: __t.string(),
  createdAt: __t.timestamp(),
  readAt: __t.option(__t.timestamp()),
  inApp: __t.bool(),
  emailStatus: __t.string(),
  emailAt: __t.timestamp(),
  assetId: __t.string(),
});
export type Notification = __Infer<typeof Notification>;

export const NotificationSettings = __t.object("NotificationSettings", {
  userId: __t.string(),
  prefs: __t.string(),
  updatedAt: __t.timestamp(),
});
export type NotificationSettings = __Infer<typeof NotificationSettings>;

export const Org = __t.object("Org", {
  id: __t.string(),
  name: __t.string(),
  slug: __t.string(),
  createdAt: __t.timestamp(),
  createdByUserId: __t.string(),
  storageLimitBytes: __t.f64(),
  storageUsedBytes: __t.f64(),
  plan: __t.string(),
  billingStatus: __t.string(),
  stripeCustomerId: __t.string(),
  stripeSubscriptionId: __t.string(),
  suspended: __t.bool(),
  seats: __t.u32(),
  billingInterval: __t.string(),
  extraStorageGb: __t.f64(),
  customStorageGb: __t.f64(),
  trialEndsAt: __t.option(__t.timestamp()),
  currentPeriodEnd: __t.option(__t.timestamp()),
  overLimitSince: __t.option(__t.timestamp()),
  billingNotices: __t.u32(),
  invoiceDays: __t.u32(),
  invoiceRequestedAt: __t.option(__t.timestamp()),
  cancelAt: __t.option(__t.timestamp()),
});
export type Org = __Infer<typeof Org>;

export const OrgInvite = __t.object("OrgInvite", {
  id: __t.string(),
  orgId: __t.string(),
  orgName: __t.string(),
  email: __t.string(),
  role: __t.string(),
  invitedByUserId: __t.string(),
  invitedByName: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.timestamp(),
  status: __t.string(),
  grantTargetKind: __t.string(),
  grantTargetId: __t.string(),
  grantRole: __t.string(),
  grantTargetName: __t.string(),
});
export type OrgInvite = __Infer<typeof OrgInvite>;

export const OrgMember = __t.object("OrgMember", {
  id: __t.string(),
  orgId: __t.string(),
  userId: __t.string(),
  role: __t.string(),
  name: __t.string(),
  email: __t.string(),
  avatarUrl: __t.string(),
  joinedAt: __t.timestamp(),
});
export type OrgMember = __Infer<typeof OrgMember>;

export const OrgUsage = __t.object("OrgUsage", {
  id: __t.string(),
  orgId: __t.string(),
  period: __t.string(),
  renderMinutes: __t.f64(),
  aiMinutes: __t.f64(),
  bonusRenderMinutes: __t.f64(),
  exports: __t.u32(),
  workerSeconds: __t.f64(),
  gpuSeconds: __t.f64(),
  updatedAt: __t.timestamp(),
});
export type OrgUsage = __Infer<typeof OrgUsage>;

export const OrgWorkerChoices = __t.object("OrgWorkerChoices", {});
export type OrgWorkerChoices = __Infer<typeof OrgWorkerChoices>;

export const OrgWorkerRow = __t.object("OrgWorkerRow", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  hwaccel: __t.string(),
  hostname: __t.string(),
  version: __t.string(),
  online: __t.bool(),
  disabled: __t.bool(),
  busy: __t.bool(),
  lastSeenAt: __t.timestamp(),
  createdAt: __t.timestamp(),
  sourceRoots: __t.string(),
  updateRequested: __t.bool(),
  updateError: __t.string(),
});
export type OrgWorkerRow = __Infer<typeof OrgWorkerRow>;

export const OrgWorkers = __t.object("OrgWorkers", {});
export type OrgWorkers = __Infer<typeof OrgWorkers>;

export const Presence = __t.object("Presence", {
  connectionId: __t.connectionId(),
  identity: __t.identity(),
  orgId: __t.string(),
  projectId: __t.string(),
  userId: __t.string(),
  name: __t.string(),
  avatarUrl: __t.string(),
  color: __t.string(),
  playheadUs: __t.f64(),
  selection: __t.array(__t.string()),
  cursorUs: __t.f64(),
  cursorTrackId: __t.string(),
  playing: __t.bool(),
  updatedAt: __t.timestamp(),
  scopeId: __t.string(),
  leading: __t.bool(),
});
export type Presence = __Infer<typeof Presence>;

export const Project = __t.object("Project", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  description: __t.string(),
  width: __t.u32(),
  height: __t.u32(),
  fps: __t.f64(),
  sampleRate: __t.u32(),
  backgroundColor: __t.string(),
  durationUs: __t.f64(),
  posterAssetId: __t.string(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  updatedByName: __t.string(),
  archived: __t.bool(),
  reviewStatus: __t.string(),
  reviewRound: __t.u32(),
  reviewRequestedByName: __t.string(),
  reviewNote: __t.string(),
  template: __t.bool(),
  lastOpenedAt: __t.option(__t.timestamp()),
  reviewVersionId: __t.string(),
  spaceId: __t.string(),
  folderId: __t.string(),
  scopeId: __t.string(),
  reviewRequestedByUserId: __t.string(),
  mediaAssetIds: __t.string(),
  colorSpace: __t.string(),
  workingSpace: __t.string(),
});
export type Project = __Infer<typeof Project>;

export const ProjectAsset = __t.object("ProjectAsset", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  assetId: __t.string(),
  scopeId: __t.string(),
});
export type ProjectAsset = __Infer<typeof ProjectAsset>;

export const ProjectFolder = __t.object("ProjectFolder", {
  id: __t.string(),
  orgId: __t.string(),
  spaceId: __t.string(),
  parentId: __t.string(),
  name: __t.string(),
  restricted: __t.bool(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
});
export type ProjectFolder = __Infer<typeof ProjectFolder>;

export const ProjectSnapshot = __t.object("ProjectSnapshot", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  clipCount: __t.u32(),
  durationUs: __t.f64(),
  number: __t.u32(),
  kind: __t.string(),
  jobId: __t.string(),
  scopeId: __t.string(),
});
export type ProjectSnapshot = __Infer<typeof ProjectSnapshot>;

export const ProjectSnapshotData = __t.object("ProjectSnapshotData", {
  id: __t.string(),
  data: __t.string(),
});
export type ProjectSnapshotData = __Infer<typeof ProjectSnapshotData>;

export const ProjectWatch = __t.object("ProjectWatch", {
  id: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  userId: __t.string(),
  level: __t.string(),
  createdAt: __t.timestamp(),
});
export type ProjectWatch = __Infer<typeof ProjectWatch>;

export const ReviewDecision = __t.object("ReviewDecision", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  round: __t.u32(),
  userId: __t.string(),
  name: __t.string(),
  decision: __t.string(),
  note: __t.string(),
  createdAt: __t.timestamp(),
  jobId: __t.string(),
  scopeId: __t.string(),
  assetId: __t.string(),
  linkId: __t.string(),
});
export type ReviewDecision = __Infer<typeof ReviewDecision>;

export const ReviewLink = __t.object("ReviewLink", {
  id: __t.string(),
  token: __t.string(),
  orgId: __t.string(),
  projectId: __t.string(),
  jobId: __t.string(),
  label: __t.string(),
  allowComments: __t.bool(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  expiresAt: __t.option(__t.timestamp()),
  revoked: __t.bool(),
  versions: __t.string(),
  allowDecisions: __t.bool(),
  hasPassword: __t.bool(),
  scopeId: __t.string(),
  assetId: __t.string(),
  createdByUserId: __t.string(),
});
export type ReviewLink = __Infer<typeof ReviewLink>;

export const ReviewLinkSecret = __t.object("ReviewLinkSecret", {
  linkId: __t.string(),
  passwordHash: __t.string(),
  setAt: __t.timestamp(),
});
export type ReviewLinkSecret = __Infer<typeof ReviewLinkSecret>;

export const ScopeAccess = __t.object("ScopeAccess", {
  id: __t.string(),
  orgId: __t.string(),
  scopeId: __t.string(),
  identity: __t.identity(),
  userId: __t.string(),
  role: __t.string(),
});
export type ScopeAccess = __Infer<typeof ScopeAccess>;

export const SomehubConnection = __t.object("SomehubConnection", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  baseUrl: __t.string(),
  folder: __t.string(),
  remoteOrgName: __t.string(),
  keyHint: __t.string(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
  kind: __t.string(),
  authHeader: __t.string(),
});
export type SomehubConnection = __Infer<typeof SomehubConnection>;

export const SomehubConnectionSecret = __t.object("SomehubConnectionSecret", {
  connectionId: __t.string(),
  orgId: __t.string(),
  ciphertext: __t.string(),
  updatedAt: __t.timestamp(),
});
export type SomehubConnectionSecret = __Infer<typeof SomehubConnectionSecret>;

export const SourceImportItem = __t.object("SourceImportItem", {
  id: __t.string(),
  path: __t.string(),
  sizeBytes: __t.f64(),
});
export type SourceImportItem = __Infer<typeof SourceImportItem>;

export const SourceRequest = __t.object("SourceRequest", {
  id: __t.string(),
  orgId: __t.string(),
  sourceId: __t.string(),
  workerId: __t.string(),
  op: __t.string(),
  root: __t.string(),
  path: __t.string(),
  status: __t.string(),
  result: __t.string(),
  error: __t.string(),
  createdAt: __t.timestamp(),
});
export type SourceRequest = __Infer<typeof SourceRequest>;

export const Space = __t.object("Space", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  description: __t.string(),
  color: __t.string(),
  restricted: __t.bool(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  scopeId: __t.string(),
  createdByUserId: __t.string(),
});
export type Space = __Infer<typeof Space>;

export const StorageGc = __t.object("StorageGc", {
  id: __t.string(),
  key: __t.string(),
  isPrefix: __t.bool(),
  createdAt: __t.timestamp(),
  attempts: __t.u32(),
});
export type StorageGc = __Infer<typeof StorageGc>;

export const StorageSource = __t.object("StorageSource", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  kind: __t.string(),
  config: __t.string(),
  spaceId: __t.string(),
  scopeId: __t.string(),
  allowWrite: __t.bool(),
  hasSecret: __t.bool(),
  lastError: __t.string(),
  createdByUserId: __t.string(),
  createdByName: __t.string(),
  createdAt: __t.timestamp(),
  updatedAt: __t.timestamp(),
});
export type StorageSource = __Infer<typeof StorageSource>;

export const StorageSourceSecret = __t.object("StorageSourceSecret", {
  sourceId: __t.string(),
  orgId: __t.string(),
  ciphertext: __t.string(),
  updatedAt: __t.timestamp(),
});
export type StorageSourceSecret = __Infer<typeof StorageSourceSecret>;

export const TextProps = __t.object("TextProps", {
  content: __t.string(),
  fontFamily: __t.string(),
  fontSize: __t.f64(),
  fontWeight: __t.f64(),
  italic: __t.bool(),
  color: __t.string(),
  align: __t.string(),
  lineHeight: __t.f64(),
  letterSpacing: __t.f64(),
  strokeColor: __t.string(),
  strokeWidth: __t.f64(),
  shadowColor: __t.string(),
  shadowBlur: __t.f64(),
  shadowX: __t.f64(),
  shadowY: __t.f64(),
  background: __t.string(),
  padding: __t.f64(),
  maxWidth: __t.f64(),
});
export type TextProps = __Infer<typeof TextProps>;

export const Track = __t.object("Track", {
  id: __t.string(),
  projectId: __t.string(),
  orgId: __t.string(),
  kind: __t.string(),
  name: __t.string(),
  order: __t.f64(),
  muted: __t.bool(),
  hidden: __t.bool(),
  locked: __t.bool(),
  solo: __t.bool(),
  volume: __t.f64(),
  pan: __t.f64(),
  scopeId: __t.string(),
  groupName: __t.string(),
  motion: __t.string(),
});
export type Track = __Infer<typeof Track>;

export const TrackInput = __t.object("TrackInput", {
  id: __t.string(),
  kind: __t.string(),
  name: __t.string(),
  order: __t.f64(),
});
export type TrackInput = __Infer<typeof TrackInput>;

export const TrackPatch = __t.object("TrackPatch", {
  name: __t.option(__t.string()),
  order: __t.option(__t.f64()),
  muted: __t.option(__t.bool()),
  hidden: __t.option(__t.bool()),
  locked: __t.option(__t.bool()),
  solo: __t.option(__t.bool()),
  volume: __t.option(__t.f64()),
  pan: __t.option(__t.f64()),
  groupName: __t.option(__t.string()),
  motion: __t.option(__t.string()),
});
export type TrackPatch = __Infer<typeof TrackPatch>;

export const TrackUpdate = __t.object("TrackUpdate", {
  id: __t.string(),
  get patch() {
    return TrackPatch;
  },
});
export type TrackUpdate = __Infer<typeof TrackUpdate>;

export const Transform = __t.object("Transform", {
  x: __t.f64(),
  y: __t.f64(),
  scale: __t.f64(),
  rotation: __t.f64(),
  opacity: __t.f64(),
  flipH: __t.bool(),
  flipV: __t.bool(),
});
export type Transform = __Infer<typeof Transform>;

// The tagged union or sum type for the algebraic type `TransitionPatch`.
export const TransitionPatch = __t.enum("TransitionPatch", {
  get Set() {
    return TransitionRef;
  },
  Clear: __t.unit(),
});
export type TransitionPatch = __Infer<typeof TransitionPatch>;

export const TransitionRef = __t.object("TransitionRef", {
  kind: __t.string(),
  durationUs: __t.f64(),
});
export type TransitionRef = __Infer<typeof TransitionRef>;

export const TrashItem = __t.object("TrashItem", {
  id: __t.string(),
  orgId: __t.string(),
  orgName: __t.string(),
  kind: __t.string(),
  targetId: __t.string(),
  name: __t.string(),
  deletedAt: __t.timestamp(),
  deletedByUserId: __t.string(),
  deletedByName: __t.string(),
  purgeAt: __t.timestamp(),
  bytes: __t.f64(),
  rowCount: __t.u32(),
  data: __t.string(),
});
export type TrashItem = __Infer<typeof TrashItem>;

export const UserGroup = __t.object("UserGroup", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  description: __t.string(),
  createdAt: __t.timestamp(),
});
export type UserGroup = __Infer<typeof UserGroup>;

export const VideoFx = __t.object("VideoFx", {
  filter: __t.string(),
  filterIntensity: __t.f64(),
  blur: __t.f64(),
  sharpen: __t.f64(),
  vignette: __t.f64(),
});
export type VideoFx = __Infer<typeof VideoFx>;

export const WatchdogSchedule = __t.object("WatchdogSchedule", {
  scheduledId: __t.u64(),
  scheduledAt: __t.scheduleAt(),
});
export type WatchdogSchedule = __Infer<typeof WatchdogSchedule>;

export const Worker = __t.object("Worker", {
  id: __t.string(),
  name: __t.string(),
  tokenSubject: __t.string(),
  identity: __t.option(__t.identity()),
  pools: __t.array(__t.string()),
  gpu: __t.bool(),
  hwaccel: __t.string(),
  hostname: __t.string(),
  version: __t.string(),
  online: __t.bool(),
  disabled: __t.bool(),
  currentJobId: __t.string(),
  lastSeenAt: __t.timestamp(),
  createdAt: __t.timestamp(),
  ephemeral: __t.bool(),
  sourceRoots: __t.string(),
  updateRequested: __t.bool(),
  updateError: __t.string(),
});
export type Worker = __Infer<typeof Worker>;

export const WorkerAccess = __t.object("WorkerAccess", {
  id: __t.string(),
  workerId: __t.string(),
  identity: __t.identity(),
  pool: __t.string(),
});
export type WorkerAccess = __Infer<typeof WorkerAccess>;

export const WorkerChoiceRow = __t.object("WorkerChoiceRow", {
  id: __t.string(),
  orgId: __t.string(),
  name: __t.string(),
  hwaccel: __t.string(),
  online: __t.bool(),
  busy: __t.bool(),
});
export type WorkerChoiceRow = __Infer<typeof WorkerChoiceRow>;

export const WorkerPoolStatusRow = __t.object("WorkerPoolStatusRow", {
  pool: __t.string(),
  online: __t.u32(),
  busy: __t.u32(),
});
export type WorkerPoolStatusRow = __Infer<typeof WorkerPoolStatusRow>;

export const WorkerPools = __t.object("WorkerPools", {});
export type WorkerPools = __Infer<typeof WorkerPools>;

export const WorkerScaling = __t.object("WorkerScaling", {
  id: __t.u32(),
  enabled: __t.bool(),
  minReplicas: __t.u32(),
  maxReplicas: __t.u32(),
  jobsPerReplica: __t.u32(),
  scaleDownDelaySeconds: __t.u32(),
  replicas: __t.u32(),
  desired: __t.u32(),
  error: __t.string(),
  lastScaledAt: __t.option(__t.timestamp()),
  updatedAt: __t.timestamp(),
});
export type WorkerScaling = __Infer<typeof WorkerScaling>;

export const WorkerSelf = __t.object("WorkerSelf", {});
export type WorkerSelf = __Infer<typeof WorkerSelf>;

export const WorkerSelfRow = __t.object("WorkerSelfRow", {
  id: __t.string(),
  updateRequested: __t.bool(),
});
export type WorkerSelfRow = __Infer<typeof WorkerSelfRow>;

